import { Image } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { Body } from "capitalrx-components-2.0/lib/typography";

import styles from "./WhiteLabelNavbar.module.scss";
import { getBrandLogo, getBrandName } from "@/utils/branding";

export const Navbar = () => {
  const brandName = getBrandName();
  const brandLogo = getBrandLogo();
  return (
    <Shelf className={styles.WhiteLabelNavbar}>
      <div role="img" aria-label="client logo" className={styles["LogoImage"]} />
      <Shelf.Spacer />
      <Body className={styles.WhiteLabelNavbarText}>Powered by <Image src={brandLogo} alt={`${brandName} Logo`} /></Body>
    </Shelf>
  );
};
